import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { Typography, TypographyOwnProps } from '@mui/material';
import { Box, SxProps } from '@mui/system';
import { DateTimeFormatOptions } from 'luxon';
import React from 'react';

export type TableCellDateProps = {
    date: Date | string | null;
    textVariant?: TypographyOwnProps['variant'];
    displayCalendar?: boolean;
    dateFormat?: DateTimeFormatOptions;
    cellSx?: SxProps;
    textSx?: SxProps;
    iconSx?: SxProps;
};

export const TableCellDate: React.FunctionComponent<TableCellDateProps> = function ({
    displayCalendar = false,
    textVariant = 'l2dtableCell',
    date = null,
    dateFormat = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    },
    cellSx = null,
    textSx = null,
    iconSx = null,
}) {
    let displayedDate = null;

    // Check type of date props
    if (date instanceof Date) {
        displayedDate = date.toLocaleDateString('fr', dateFormat);
    } else if (date) {
        displayedDate = new Date(date).toLocaleDateString('fr', dateFormat);
    }

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                gap: '4px',
                alignItems: 'center',
                color: 'text.gris70',
                ...cellSx,
            }}
        >
            {displayedDate && (
                <>
                    {displayCalendar && (
                        <FaOptionIcon
                            icon={['fasl', 'calendar']}
                            sx={iconSx}
                        />
                    )}

                    <Typography
                        variant={textVariant}
                        sx={textSx}
                    >
                        {displayedDate}
                    </Typography>
                </>
            )}
        </Box>
    );
};
